import React, { Component } from 'react';
import ErrorFlag from '@atlassian/jira-flags/src/common/ui/components/error-flag';
import FlagGroup from '@atlassian/jira-flags/src/common/ui/components/group-flag';
import SuccessFlag from '@atlassian/jira-flags/src/common/ui/components/success-auto-dismiss-flag';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import {
	AvatarFetchFailedFlag,
	AvatarUploadFailedFlag,
} from '@atlassian/jira-project-settings-apps-common/src/avatar-service/avatar-flags';
import type { DismissFlagTypeAction } from '../../state/ui/actions';
import {
	DELETE_PROJECT_FAIL_FLAG,
	DELETE_PROJECT_SUCCESS_FLAG,
	GENERIC_ERROR_FLAG,
	SUBMIT_SUCCESS_FLAG,
	type Flag,
	AVATAR_UPLOAD_FAIL_FLAG,
	AVATAR_FETCH_FAIL_FLAG,
	RELEASE_KEYS_ERROR,
	type ValidationErrors,
} from '../../state/ui/types';
import messages from './messages';

export type StateProps = {
	flags: Flag[];
	projectName: string;
	validationErrors: ValidationErrors;
};

export type DispatchProps = {
	onDismissed: (arg1: string | number) => DismissFlagTypeAction;
};

type Props = StateProps &
	DispatchProps & {
		intl: IntlShape;
	};

// eslint-disable-next-line jira/react/no-class-components
export class Flags extends Component<Props> {
	renderFlag = (flag: Flag) => {
		const {
			intl: { formatMessage },
			projectName,
			validationErrors,
		} = this.props;

		switch (flag.type) {
			case SUBMIT_SUCCESS_FLAG:
				return (
					<SuccessFlag
						key={flag.id}
						id={flag.id}
						title={formatMessage(messages.submitSuccessTitle)}
						description={formatMessage(messages.submitSuccessDescription)}
					/>
				);
			case RELEASE_KEYS_ERROR:
				return (
					<ErrorFlag
						key={flag.id}
						id={flag.id}
						title={formatMessage(messages.releaseProjectKeysErrorTitle)}
						// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
						description={validationErrors.releaseProjectKeysError.body}
					/>
				);

			case GENERIC_ERROR_FLAG:
				return (
					<ErrorFlag
						key={flag.id}
						id={flag.id}
						title={formatMessage(messages.genericErrorTitle)}
						description={formatMessage(messages.genericErrorDescription)}
					/>
				);

			case DELETE_PROJECT_SUCCESS_FLAG:
				return (
					<SuccessFlag
						key={flag.id}
						id={flag.id}
						title={formatMessage(messages.deleteProjectSuccessTitle)}
						description={formatMessage(messages.deleteProjectSuccessDescription, {
							projectName,
						})}
					/>
				);
			case DELETE_PROJECT_FAIL_FLAG:
				return (
					<ErrorFlag
						key={flag.id}
						id={flag.id}
						title={formatMessage(messages.deleteProjectFailTitle)}
						description={formatMessage(messages.deleteProjectFailDescription, {
							projectName,
						})}
					/>
				);
			case AVATAR_FETCH_FAIL_FLAG:
				// @ts-expect-error - TS2322 - Type '{ key: string; id: string; isDismissAllowed: true; }' is not assignable to type 'IntrinsicAttributes & { id: string | number; onDismissed: (id: string | number) => void; } & FlagComponentDefaultProps & { ...; }'.
				return <AvatarFetchFailedFlag key={flag.id} id={flag.id} isDismissAllowed />;
			case AVATAR_UPLOAD_FAIL_FLAG:
				// @ts-expect-error - TS2322 - Type '{ key: string; id: string; isDismissAllowed: true; }' is not assignable to type 'IntrinsicAttributes & { id: string | number; onDismissed: (id: string | number) => void; } & FlagComponentDefaultProps & { ...; }'.
				return <AvatarUploadFailedFlag key={flag.id} id={flag.id} isDismissAllowed />;

			default:
				return null;
		}
	};

	render() {
		const { onDismissed, flags } = this.props;
		const cloneFlags = [...flags];
		return (
			<FlagGroup onDismissed={onDismissed}>
				{/* @ts-expect-error - TS2322 - Type '(Element | null)[]' is not assignable to type 'boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactElement<any, string | JSXElementConstructor<any>>[] | null | undefined'. */}
				{cloneFlags.reverse().map(this.renderFlag)}
			</FlagGroup>
		);
	}
}

export default injectIntl(Flags);
